import React from 'react'
import * as R from 'ramda'
import { Box } from 'components/layout/Box/Box'
import { SecondaryTabsBar } from 'components/shared/SecondaryTabsBar/SecondaryTabsBar'
import { Trait } from '../Trait/Trait'
import { personalityOverviewTab } from '../../model'
import styles from './PersonalityFactors.module.scss'
import { PersonalityOverview } from './PersonalityOverview/PersonalityOverview'
import { hasCaution } from '../cautions'

export const PersonalityFactors = ({
  language,
  factors,
  scores,
  personalityTab,
  setPersonalityTab,
  selectedCandidates,
  setSelectedCandidates,
  response,
  candidates,
  name,
  cautions = [],
}) => {
  const tabConfig = R.find(R.propEq('id', personalityTab), factors)
  const factor = R.prop('factor', tabConfig)
  const overviewTab = personalityOverviewTab()
  const single = candidates.length === 1

  return (
    <Box align="center" direction="column" className={styles.personailty}>
      <SecondaryTabsBar
        tabs={[
          overviewTab,
          ...R.map(
            ({ label, id, factor }) => ({
              id,
              label,
              caution: hasCaution(cautions, factor) ? 1 : 0,
            }),
            factors,
          ),
        ]}
        activeTab={personalityTab}
        setActiveTab={setPersonalityTab}
      />
      {personalityTab === overviewTab.id ? (
        <PersonalityOverview
          {...{
            factors,
            language,
            single,
            response,
            scores,
            candidates,
            selectedCandidates,
            setSelectedCandidates,
            setPersonalityTab,
            name,
            cautions,
          }}
        />
      ) : (
        <Trait
          minimize
          key={factor}
          groups={tabConfig?.groups}
          {...{
            factor,
            language,
            scores,
            name,
            single,
            response,
            selectedCandidates,
            setSelectedCandidates,
            candidates,
            cautions,
          }}
        />
      )}
    </Box>
  )
}
